'use strict'

const _ = require('lodash')
// const BaccaratRoadmap = use('App/Support/PlayingCards/BaccaratRoadmap')
const BaccaratRoadmap = require('./BaccaratRoadmap')

class DragonTigerRoadmap extends BaccaratRoadmap {

  askPlayer(statistic) {
    const newData = {
      winner: 'TIGER'
    }
    return _.concat(statistic, newData)
  }

  askBanker(statistic) {
    const newData = {
      winner: 'DRAGON'
    }
    return _.concat(statistic, newData)
  }

}

module.exports = DragonTigerRoadmap



// WEBPACK FOOTER //
// ./app/Support/PlayingCards/DragonTigerRoadmap.js